<script setup>
import i18next from 'i18next';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { TickerTape } from 'vue-tradingview-widgets';
import { useCcm19Global } from '../../../useCcm19Global';
import Intro from '../Intro.vue';
import BreakingNewsList from './BreakingNewsList.vue';

const route = useRoute();

const breakingNewsId = computed(() => route.query.id || null);

const { onReady, tradingView } = useCcm19Global();
onReady(() => {});
</script>

<template>
    <div>
        <TickerTape
            v-if="tradingView"
            :options="{
                symbols: [
                    { proName: 'FOREXCOM:SPXUSD', title: 'S&P 500' },
                    { proName: 'BITSTAMP:BTCUSD', title: 'Bitcoin' },
                    { proName: 'BITSTAMP:ETHUSD', title: 'Ethereum' },
                    { description: 'DAX', proName: 'XETR:DAX' },
                    { description: 'Gold', proName: 'TVC:GOLD' },
                    { description: i18next.t('plain_silver'), proName: 'TVC:SILVER' },
                    { description: 'WTI', proName: 'TVC:USOIL' },
                    { description: 'EUR/USD', proName: 'FX:EURUSD' }
                ],
                showSymbolLogo: true,
                colorTheme: 'light',
                isTransparent: false,
                displayMode: 'adaptive',
                locale: 'de'
            }"
        />

        <div class="container mx-auto">
            <Intro class="my-4" />

            <div class="flex flex-row justify-between items-center">
                <p class="text-xl font-semibold my-4">Schlagzeilen</p>

                <div>
                    <router-link
                        to="/hkcmnews"
                        class="inline-flex items-center gap-2 hover:text-blue hover:bg-gray-100 text-sm transition-all ease-in-out p-1 px-2 rounded-md cursor-pointer"
                    >
                        <span> Alle News </span>
                        <svg class="h-3" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.39685 3H10.2857H1.39685Z" fill="currentColor" />
                            <path d="M1.39685 3H10.2857" stroke="currentColor" stroke-width="0.47619" />
                            <path d="M7.42859 0.428589L10.2857 3.00002L7.42859 5.57145" stroke="currentColor" stroke-width="0.47619" stroke-linecap="square" />
                        </svg>
                    </router-link>
                </div>
            </div>

            <BreakingNewsList class="my-4" :scroll-to-id="breakingNewsId" />
        </div>
    </div>
</template>
